import React from "react";

export default function TaglineLight(){
    return(
        <>
        <div className="tagline bg-white dark:bg-slate-900">
            <div className="container relative">                
                <div className="grid grid-cols-1">
                    <div className="text-center">
                        <h6 className="text-slate-900 dark:text-white font-semibold">Refer a friend & get $50 in credits each 🎉</h6>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}